import React, { useEffect, useState, forwardRef } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";  // Import the default styles from react-datepicker
import './MonthPicker.scss';  // Import your custom styles
import { sv } from 'date-fns/locale';  // Swedish locale

interface MonthPickerProps {
    selectedDate: Date | null;
    onDateChange: (newDate: Date | null) => void;
    loading: boolean; // Prop to disable interaction
    minDate?: Date; // Optional prop to restrict date selection to this minimum
}

export const MonthPicker: React.FC<MonthPickerProps> = ({ selectedDate, onDateChange, loading, minDate }) => {
    const [currentDate, setCurrentDate] = useState<Date | null>(selectedDate || new Date());

    useEffect(() => {
        // Register Swedish locale
        registerLocale('sv', sv);
    }, []);

    useEffect(() => {
        // Update currentDate whenever selectedDate changes
        setCurrentDate(selectedDate);
    }, [selectedDate]);

    const handleDateChange = (date: Date | null) => {
        if (!loading) {
            setCurrentDate(date);
            onDateChange(date); // Pass the selected date to the parent component
        }
    };

    // Custom input component to prevent manual input
    const CustomInput = forwardRef(({ value, onClick }: any, ref: any) => (
        <button
            className="form-control date-picker-input"
            onClick={loading ? undefined : onClick}  // Disable click when loading
            ref={ref}
            style={{ opacity: loading ? 0.5 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}  // Visual feedback
            disabled={loading} // Disable the button when loading
        >
            {value || "ÅÅÅÅ-MM"} {/* Translated placeholder */}
        </button>
    ));

    return (
        <div className="month-picker-container">
            <DatePicker
                selected={currentDate}
                onChange={handleDateChange}
                dateFormat="yyyy-MM"          // Format as "YYYY-MM"
                showMonthYearPicker           // Only allow month and year selection
                locale="sv"                   // Set locale to Swedish
                customInput={<CustomInput />} // Use custom input component
                disabled={loading}            // Disable the DatePicker when loading
                minDate={minDate}             // Set the minimum selectable date
             
  
  
            />
        </div>
    );
};

export default MonthPicker;
